import { toast } from "react-toastify";

const TOAST_DEFAULTS = {
  position: "bottom-right",
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export const toastService = {
  success: (message, options = {}) =>
    toast.success(message, {
      autoClose: 3000,
      ...TOAST_DEFAULTS,
      ...options,
    }),

  error: (message, options = {}) =>
    toast.error(message, {
      autoClose: 5000,
      ...TOAST_DEFAULTS,
      ...options,
    }),

  warning: (message, options = {}) =>
    toast.warning(message, {
      autoClose: 4000,
      ...TOAST_DEFAULTS,
      ...options,
    }),

  info: (message, options = {}) =>
    toast.info(message, {
      autoClose: 3000,
      ...TOAST_DEFAULTS,
      ...options,
    }),

  promise: (promise, messages, options = {}) =>
    toast.promise(
      promise,
      {
        pending: messages.pending || "Loading...",
        success: messages.success || "Success!",
        error: messages.error || "Something went wrong!",
      },
      {
        ...TOAST_DEFAULTS,
        ...options,
      }
    ),
};
